(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anza-buffalo-horn-v4"]) return;
  try {
    
(() => {
  function initBowie() {
    const root = document.querySelector('[data-anza-bowie]');
    if (!root || root.dataset.enhanced) return;
    const variants = JSON.parse(root.querySelector('[data-bowie-variants]').textContent);
    const select = root.querySelector('[data-variant-select]');
    const quantity = root.querySelector('[name="quantity"]');
    const photos = [...root.querySelectorAll('.zh-thumbnail')];
    const main = root.querySelector('.zh-main-photo');
    const stage = root.querySelector('.zh-stage');
    const dialog = root.querySelector('.zh-zoom');
    const add = root.querySelector('[data-zg3-add]');
    const form = root.querySelector('form');
    root.dataset.enhanced = 'true';
    function clampQuantity() {
      quantity.value = String(Math.max(1, Math.min(Number(quantity.max) || 99, Math.floor(Number(quantity.value) || 1))));
    }
    function showPhoto(key) {
      const photo = photos.find(item => item.dataset.view === key);
      if (!photo) return;
      stage.dataset.view = key;
      main.src = photo.dataset.src;
      main.srcset = photo.dataset.srcset;
      main.alt = photo.dataset.alt;
      root.querySelector('.zh-caption').textContent = photo.dataset.caption;
      root.querySelector('[data-image-count]').textContent = (photos.indexOf(photo) + 1) + ' / ' + photos.length;
      photos.forEach(item => item.setAttribute('aria-pressed', String(item === photo)));
      const zoomImage = root.querySelector('[data-zoom-image]');
      zoomImage.src = photo.dataset.src;
      zoomImage.alt = photo.dataset.alt;
    }
    function updateVariant(id, changePhoto, updateUrl) {
      const variant = variants.find(item => String(item.id) === String(id));
      if (!variant) return;
      select.value = String(variant.id);
      root.querySelectorAll('[data-variant-id]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.variantId === String(variant.id))));
      root.querySelector('[data-price]').textContent = variant.price;
      const compare = root.querySelector('[data-compare]');
      compare.hidden = !variant.compare;
      compare.textContent = variant.compare || '';
      const stock = root.querySelector('[data-stock]');
      stock.textContent = variant.stock;
      stock.classList.toggle('zh-stock-out', !variant.available);
      root.querySelectorAll('[data-shipping]').forEach(el => { el.textContent = variant.shipping; });
      root.querySelector('[data-summary]').textContent = variant.title + ' · ' + variant.price + ' · ' + variant.shipping;
      root.querySelector('[data-selected-sheath]').textContent = variant.title;
      root.querySelector('[data-choice-description]').textContent = variant.description;
      quantity.max = String(variant.limit);
      clampQuantity();
      add.disabled = !variant.available;
      add.textContent = variant.available ? add.dataset.label : add.dataset.labelSold;
      const payment = root.querySelector('[data-payment]');
      if (payment) payment.hidden = !variant.available;
      root.querySelector('[data-bis]').hidden = variant.available;
      root.querySelector('[data-zg3-note]').hidden = true;
      if (changePhoto) showPhoto(variant.sheath);
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
      form.dispatchEvent(new CustomEvent('variant:change', {bubbles: true, detail: {variant}}));
    }
    photos.forEach(button => button.addEventListener('click', () => showPhoto(button.dataset.view)));
    root.querySelectorAll('[data-variant-id]').forEach(button => button.addEventListener('click', () => {
      if (add.getAttribute('aria-busy') === 'true') return;
      select.value = button.dataset.variantId;
      select.dispatchEvent(new Event('change', {bubbles: true}));
    }));
    select.addEventListener('change', () => updateVariant(select.value, true, true));
    root.querySelectorAll('[data-quantity]').forEach(button => button.addEventListener('click', () => {
      quantity.value = Number(quantity.value) + Number(button.dataset.quantity);
      clampQuantity();
      quantity.dispatchEvent(new Event('change', {bubbles: true}));
    }));
    quantity.addEventListener('change', clampQuantity);
    root.querySelector('[data-zoom-open]').addEventListener('click', () => dialog.showModal());
    root.querySelector('[data-zoom-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    root.querySelectorAll('a[href="#bowie-terms"]').forEach(link => link.addEventListener('click', () => { root.querySelector('#bowie-terms').open = true; }));
    window.addEventListener('popstate', () => {
      const id = new URL(window.location.href).searchParams.get('variant');
      if (id) updateVariant(id, true, false);
    });
    let touchX = null;
    stage.addEventListener('touchstart', event => { touchX = event.changedTouches[0].clientX; }, {passive: true});
    stage.addEventListener('touchend', event => {
      if (touchX === null) return;
      const difference = event.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(difference) < 50) return;
      const current = photos.findIndex(photo => photo.getAttribute('aria-pressed') === 'true');
      showPhoto(photos[(current + (difference < 0 ? 1 : -1) + photos.length) % photos.length].dataset.view);
    }, {passive: true});
    updateVariant(select.value, false, false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBowie);
  else initBowie();
  document.addEventListener('shopify:section:load', initBowie);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zh-product-editorial"] && !Shopify.designMode) return;
  try {
    

(() => {
  function initEditorial() {
    const root = document.querySelector('[data-zh-editorial]');
    if (!root || root.dataset.enhanced) return;
    const variants = JSON.parse(root.querySelector('[data-editorial-variants]').textContent);
    const select = root.querySelector('[data-variant-select]');
    const quantity = root.querySelector('[name="quantity"]');
    const photos = [...root.querySelectorAll('.zh-thumbnail')];
    const main = root.querySelector('.zh-main-photo');
    const stage = root.querySelector('.zh-stage');
    const dialog = root.querySelector('.zh-zoom');
    const add = root.querySelector('[data-zg3-add]');
    const form = root.querySelector('form');
    root.dataset.enhanced = 'true';
    function clampQuantity() {
      quantity.value = String(Math.max(1, Math.min(Number(quantity.max) || 99, Math.floor(Number(quantity.value) || 1))));
    }
    function showPhoto(key) {
      const photo = photos.find(item => item.dataset.view === key);
      if (!photo) return;
      stage.dataset.view = key;
      main.src = photo.dataset.src;
      main.srcset = photo.dataset.srcset;
      main.alt = photo.dataset.alt;
      root.querySelector('.zh-caption').textContent = photo.dataset.caption;
      root.querySelector('[data-image-count]').textContent = (photos.indexOf(photo) + 1) + ' / ' + photos.length;
      photos.forEach(item => item.setAttribute('aria-pressed', String(item === photo)));
      const zoomImage = root.querySelector('[data-zoom-image]');
      zoomImage.src = photo.dataset.src;
      zoomImage.alt = photo.dataset.alt;
    }
    function updateVariant(id, changePhoto, updateUrl) {
      const variant = variants.find(item => String(item.id) === String(id));
      if (!variant) return;
      select.value = String(variant.id);
      root.querySelectorAll('[data-variant-id]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.variantId === String(variant.id))));
      root.querySelector('[data-price]').textContent = variant.price;
      const compare = root.querySelector('[data-compare]');
      compare.hidden = !variant.compare;
      compare.textContent = variant.compare || '';
      const stock = root.querySelector('[data-stock]');
      stock.textContent = variant.stock;
      stock.classList.toggle('zh-stock-out', !variant.available);
      root.querySelectorAll('[data-shipping]').forEach(el => { el.textContent = variant.shipping; });
      root.querySelector('[data-summary]').textContent = (root.dataset.defaultVariant === 'true' ? '' : variant.title + ' · ') + variant.price + ' · ' + variant.shipping;
      const selectedSheath = root.querySelector('[data-selected-sheath]');
      if (selectedSheath) selectedSheath.textContent = variant.title;
      const choiceDescription = root.querySelector('[data-choice-description]');
      if (choiceDescription) choiceDescription.textContent = variant.description;
      quantity.max = String(variant.limit);
      clampQuantity();
      add.disabled = !variant.available;
      add.dataset.label = variant.buttonLabel;
      add.textContent = variant.available ? add.dataset.label : add.dataset.labelSold;
      const payment = root.querySelector('[data-payment]');
      if (payment) payment.hidden = !variant.available;
      root.querySelector('[data-bis]').hidden = variant.available;
      root.querySelector('[data-zg3-note]').hidden = true;
      if (changePhoto && variant.sheath) showPhoto(variant.sheath);
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
      form.dispatchEvent(new CustomEvent('variant:change', {bubbles: true, detail: {variant}}));
    }
    photos.forEach(button => {
      button.addEventListener('click', () => showPhoto(button.dataset.view));
      button.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const index = (photos.indexOf(button) + (event.key === 'ArrowRight' ? 1 : -1) + photos.length) % photos.length;
        photos[index].focus();
        showPhoto(photos[index].dataset.view);
      });
    });
    root.querySelectorAll('[data-variant-id]').forEach(button => button.addEventListener('click', () => {
      if (add.getAttribute('aria-busy') === 'true') return;
      select.value = button.dataset.variantId;
      select.dispatchEvent(new Event('change', {bubbles: true}));
    }));
    select.addEventListener('change', () => updateVariant(select.value, true, true));
    root.querySelectorAll('[data-quantity]').forEach(button => button.addEventListener('click', () => {
      quantity.value = Number(quantity.value) + Number(button.dataset.quantity);
      clampQuantity();
      quantity.dispatchEvent(new Event('change', {bubbles: true}));
    }));
    quantity.addEventListener('change', clampQuantity);
    root.querySelector('[data-zoom-open]').addEventListener('click', () => dialog.showModal());
    root.querySelector('[data-zoom-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    root.querySelectorAll('a[href="#editorial-terms"]').forEach(link => link.addEventListener('click', () => { root.querySelector('#editorial-terms').open = true; }));
    window.addEventListener('popstate', () => {
      const id = new URL(window.location.href).searchParams.get('variant');
      if (id) updateVariant(id, true, false);
    });
    let touchX = null;
    stage.addEventListener('touchstart', event => { touchX = event.changedTouches[0].clientX; }, {passive: true});
    stage.addEventListener('touchend', event => {
      if (touchX === null) return;
      const difference = event.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(difference) < 50) return;
      const current = photos.findIndex(photo => photo.getAttribute('aria-pressed') === 'true');
      showPhoto(photos[(current + (difference < 0 ? 1 : -1) + photos.length) % photos.length].dataset.view);
    }, {passive: true});
    updateVariant(select.value, false, false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initEditorial);
  else initEditorial();
  document.addEventListener('shopify:section:load', initEditorial);
})();


  } catch(e) { console.error(e); }
})();
})();
